import axios from 'axios'

const api = axios.create({
  baseURL: '/api/luggage-storage',
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
})

export default {
  getStoreFees (storeId) {
    return api.get(`/stores/${storeId}/fees`)
  },

  createBooking (data) {
    return api.post('/bookings', data)
  },

  getBooking (token) {
    return api.get(`/bookings/${token}`)
  },

  updateBooking (token, data) {
    return api.put(`/bookings/${token}`, data)
  },

  cancelBooking (token) {
    return api.post(`/bookings/${token}/cancel`)
  },

  estimatePrice (data) {
    return api.post('/bookings/estimate', data)
  },

  uploadSignature (blob) {
    const formData = new FormData()
    formData.append('file', blob, 'signature.png')
    formData.append('type', 'signature')
    return axios.post('/photo/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/booking.js